import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ServicePackageCard } from '../../shared';

const ServicesTab = ({ service }) => {
  const navigate = useNavigate();

  return (
    <div>
      <h3 className="marketing-display-md mb-2 text-m-ink">Service packages</h3>
      <p className="mb-6 text-sm text-m-ink-muted">
        Choose a package to continue booking. Add-ons can be selected on the next step.
      </p>
      <div className="space-y-4">
        {service?.vendor_service_packages?.length > 0 ? (
          service.vendor_service_packages.map((pkg) => (
            <ServicePackageCard
              key={pkg.id}
              package={pkg}
              onSelect={() =>
                navigate(`/booking/${service.id}?package=${encodeURIComponent(pkg.id)}`)
              }
            />
          ))
        ) : (
          <div className="rounded-2xl border border-m-border-light bg-m-surface py-10 text-center">
            <p className="text-sm text-m-ink-muted">
              No service packages available for this service.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServicesTab;
